module.exports = __webpack_public_path__ + "img/main-banner.18c110af.png";